var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6892_63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 1C3.69147 1 1 3.69147 1 7C1 10.3085 3.69147 13 7 13C10.3085 13 13 10.3085 13 7C13 3.69147 10.3085 1 7 1Z",
    fill: "#DB2835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20971 8.50265C9.40518 8.69822 9.40518 9.01418 9.20971 9.20972C9.16333 9.25622 9.10822 9.29309 9.04754 9.31823C8.98686 9.34337 8.92182 9.35627 8.85614 9.3562C8.72817 9.3562 8.60018 9.30722 8.50265 9.20972L7.00019 7.70716L5.49773 9.20974C5.45136 9.25623 5.39625 9.29311 5.33559 9.31824C5.27492 9.34338 5.20989 9.35629 5.14422 9.35622C5.07855 9.35629 5.01351 9.34339 4.95283 9.31825C4.89216 9.29311 4.83705 9.25624 4.79067 9.20974C4.5952 9.01418 4.5952 8.69822 4.79067 8.50265L6.29322 7.00019L4.79064 5.49773C4.59518 5.30217 4.59518 4.98621 4.79064 4.79067C4.98621 4.5952 5.30217 4.5952 5.49773 4.79067L7.00019 6.29322L8.50265 4.79064C8.69822 4.59518 9.01418 4.59518 9.20971 4.79064C9.40518 4.98621 9.40518 5.30217 9.20971 5.49773L7.70716 7.00019L9.20971 8.50265Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6892_63"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.68af807ca5c92b9acaef923404a9affe.svg";
export { ForwardRef as ReactComponent };